import { InjectionToken } from '@angular/core';

export const BOSCH_UI_DIALOG_DATA = new InjectionToken('BOSCH_UI_DIALOG_DATA');
